import { render, staticRenderFns } from "./ContentWithOverlay.vue?vue&type=template&id=dfcf3ce4&"
import script from "./ContentWithOverlay.vue?vue&type=script&lang=ts&"
export * from "./ContentWithOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports